<template>
  <section class="width: 90%">
    <div class="uk-text-left container">
      <section class="section-titles">
        <h3 class="title">
          Opciones de Envío Para su Modelo de Simulación
        </h3>
        <p class="subtitle helper">
          INSTRUCCIONES: Favor seleccionar el modo de transporte del tramo internacional (Marítimo o Aéreo),
          la dirección del trayecto (Importación o Exportación), y el tipo de carga (Seca o Refrigerada).
        </p>
      </section>
      <section class="main">
        <div
          class="uk-flex uk-flex-between uk-flex-wrap item"
          style="margin-top: 5px !important;"
        >
          <label class="uk-width-1-3 labelText ">Modo de Transporte</label>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si el modo de transporte es aéreo','airplane.jpg')"
            @mouseleave="setMessageInformation()"
          >
            <label for="aerial">
              <figure>
                <img
                  src="../../../assets/img/costs/airplane.jpg"
                  style="cursor: pointer;"
                  alt="Aéreo"
                >
                <figcaption class="figure-title">
                  <input
                    id="aerial"
                    v-model="shippingOption.transportMode"
                    class="uk-radio"
                    type="radio"
                    name="transportMode"
                    :value="transportModeTypeEnum.aerial"
                  >
                  Aéreo
                </figcaption>
              </figure>
            </label>
          </div>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si el modo de transporte es Marítimo','boat.png')"
            @mouseleave="setMessageInformation()"
          >
            <label for="maritime">
              <figure>
                <img
                  src="../../../assets/img/costs/boat.png"
                  style="cursor: pointer;"
                  alt="Marítimo"
                >
                <figcaption class="figure-title">
                  <input
                    id="maritime"
                    v-model="shippingOption.transportMode"
                    class="uk-radio"
                    type="radio"
                    name="transportMode"
                    :value="transportModeTypeEnum.maritime"
                  >
                  Marítimo
                </figcaption>
              </figure>
            </label>
          </div>
        </div>
        <div
          class="uk-flex uk-flex-between uk-flex-wrap item"
          style="margin-top: 5px !important;"
        >
          <label class="uk-width-1-3 labelText">Dirección</label>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si es Importación','Import.png')"
            @mouseleave="setMessageInformation()"
          >
            <label for="import">
              <figure>
                <img
                  style="cursor: pointer"
                  src="../../../assets/img/costs/Import.png"
                  alt="Importación"
                >
                <figcaption class="figure-title">
                  <input
                    id="import"
                    v-model="shippingOption.direction"
                    class="uk-radio"
                    type="radio"
                    name="direction"
                    :value="directionTypeEnum.import"
                  >
                  Importación
                </figcaption>
              </figure>
            </label>
          </div>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si es Exportación','Export.png')"
            @mouseleave="setMessageInformation()"
          >
            <label for="export">
              <figure>
                <img
                  style="cursor: pointer"
                  src="../../../assets/img/costs/Export.png"
                  alt="Exportación"
                >
                <figcaption class="figure-title">
                  <input
                    id="export"
                    v-model="shippingOption.direction"
                    class="uk-radio"
                    type="radio"
                    name="direction"
                    :value="directionTypeEnum.export"
                  >
                  Exportación
                </figcaption>
              </figure>
            </label>
          </div>
        </div>

        <div
          class="uk-flex uk-flex-between uk-flex-wrap item"
          style="margin-top: 5px !important;"
        >
          <label class="uk-width-1-3 labelText">Tipo de Carga</label>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si el tipo de carga es Seca','dolly.png')"
            @mouseleave="setMessageInformation()"
          >
            <label for="dryCargo">
              <figure>
                <img
                  style="cursor: pointer"
                  src="../../../assets/img/costs/dolly.png"
                  alt="Carga Seca"
                >
                <figcaption class="figure-title">
                  <input
                    id="dryCargo"
                    v-model="shippingOption.dollyType"
                    class="uk-radio"
                    type="radio"
                    name="dollyType"
                    :value="dollyTypeEnum.dryLoad"
                  >
                  Carga Seca
                </figcaption>
              </figure>
            </label>
          </div>
          <div
            class="uk-width-1-3 item-child"
            @mouseover="setMessageInformation('Seleccione esta opción si el tipo de carga es Refrigerada','Reefer.png',)"
            @mouseleave="setMessageInformation()"
          >
            <label for="reefer">
              <figure>
                <img
                  style="cursor: pointer"
                  src="../../../assets/img/costs/Reefer.png"
                  alt="Reefer"
                >
                <figcaption class="figure-title">
                  <input
                    id="reefer"
                    v-model="shippingOption.dollyType"
                    class="uk-radio"
                    type="radio"
                    name="dollyType"
                    :value="dollyTypeEnum.reefer"
                  >
                  Reefer
                </figcaption>
              </figure>
            </label>
          </div>
        </div>
      </section>
    </div>

    <wizard-button :data="shippingOption" />
  </section>
</template>

<script>
import { transportModeTypeEnum, directionTypeEnum, dollyTypeEnum } from '../../../types'
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      transportModeTypeEnum,
      directionTypeEnum,
      dollyTypeEnum,

      shippingOption: {
        transportMode: null,
        direction: null,
        dollyType: null
      },
      informationMsg: {
        image: null,
        message: null
      }
    }
  },

  computed: {
    ...mapGetters([
      'transportMode',
      'journeyDirection',
      'dollyType'
    ]),
    ...mapActions([
      'resetCosts'
    ])
  },
  watch: {
    shippingOption: {
      handler: function (newVal) {
        this.$store.commit('setShippingOptions', newVal)
      },
      deep: true
    },
    transportMode: {
      handler: function (newVal) {
        this.shippingOption.transportMode = newVal
      },
      deep: true
    },
    journeyDirection: {
      handler: function (newVal) {
        this.shippingOption.direction = newVal
      },
      deep: true
    },
    dollyType: {
      handler: function (newVal) {
        this.shippingOption.dollyType = newVal
      },
      deep: true
    }
  },
  mounted () {
    this.shippingOption.transportMode = this.transportMode
    this.shippingOption.direction = this.journeyDirection
    this.shippingOption.dollyType = this.dollyType
    this.resetAll()
  },
  methods: {
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message
      this.$store.commit('setMessageInformation', this.informationMsg)
    },
    resetAll () {
      this.$store.dispatch('resetCosts')
    }
  }
}
</script>

<style scoped>

p {
  margin: 10px;
}
.container{
padding: 15px 40px ;
min-height: 418px;;

}

figure{
  width: 60%;
}
img {
  height: 62px;
  width: 62px;
  margin: auto;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;
}
.section-titles{
  width: 95%;
  padding: 0px;
}
.labelText {
  display: flex;
  font-weight:600;
  flex-direction: column;
  color: #333;
  justify-content: center;
}

.helper{
  color:rgb(119 118 118 / 58%) !important;
  margin: 10px 0px;
  text-align: justify;
}
.figure-title{
  max-width: 85px !important;
  cursor: pointer
}
@media screen and (max-width: 879px){
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
}

  .main{
    font-size: 12px;
    padding: 0px;
  }
 .container{
    padding: 15px 20px;
  }

}
@media screen and (max-width: 689px){
  .labelText{
    width: 100%;
    margin: 5px 0px;
  }
  .title{
    font-size: 13px;
  }
  .item-child{
    width: 40%;
  }

  *{
    font-size: 10px;
  }

  figcaption{
    min-width: 90px;
  }

}

</style>
